import React, {Component} from 'react'

export default class SelectIndustriesModal extends Component
{
    constructor(props)
    {
        super(props);

        let industries = TB.map(laravel.client_industries, (name, id) => {
                return {id, name}
            }
        );

        this.state = {
            ...this.state,
            isDisabled: props.disabled,
            industries
        };
    }


    render()
    {

        let {industries} = this.state;

        return (
            <div className="modal-table">

                <div className="row industries-table items-center">
                    {industries.map((industry) => (
                        <div key={"industry-" + industry.id} className="md:w-5/12 flex flex-row">
                            <p>
                                <span>
                                    {industry.name}
                                </span>
                                <span className={'btn-form-modal ml-2'}
                                   onClick={() => this.props.selectIndustry(industry)}>
                                    Select
                                </span>
                            </p>

                        </div>
                    ))}
                </div>

            </div>
        )
    }
}